import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { CustomerBonusSettlementDetails } from '../../../models/customer-bonus-settlement-details';
import { CustomerBonusSettlementSupplier } from '../../../models/customer-bonus-settlement-supplier';
import {
    bonusSettlementPoolDetailSuppliersReset,
    bonusSettlementPoolDetailsReset,
    getPoolBonusSettlementCustomerDetails,
    getPoolBonusSettlementCustomerSuppliers,
} from './bonus-settlements-pool-detail-actions';

export interface BonusSettlementsPoolDetailState {
    poolBonusSettlementCustomerDetails?: CustomerBonusSettlementDetails;
    poolBonusSettlementCustomerSuppliers: PaginatedResponse<CustomerBonusSettlementSupplier>;
    requesting: boolean;
}

const initialState: BonusSettlementsPoolDetailState = {
    requesting: false,
    poolBonusSettlementCustomerSuppliers: {
        page: 0,
        limit: 0,
        total: 0,
        items: [],
    },
};

export const bonusSettlementsPoolDetailReducer = createReducer(initialState, builder => {
    builder.addCase(bonusSettlementPoolDetailsReset, state => ({
        ...state,
        poolBonusSettlementCustomerDetails: undefined,
    }));

    builder.addCase(bonusSettlementPoolDetailSuppliersReset, state => ({
        ...state,
        poolBonusSettlementCustomerSuppliers: initialState.poolBonusSettlementCustomerSuppliers,
        requesting: false,
    }));

    builder.addCase(getPoolBonusSettlementCustomerSuppliers.pending, state => {
        state.requesting = true;
    });

    builder.addCase(getPoolBonusSettlementCustomerSuppliers.fulfilled, (state, action) => {
        if (action.payload) {
            state.poolBonusSettlementCustomerSuppliers = action.payload;
        }

        state.requesting = false;
    });

    builder.addCase(getPoolBonusSettlementCustomerDetails.pending, state => {
        state.requesting = true;
    });

    builder.addCase(getPoolBonusSettlementCustomerDetails.fulfilled, (state, action) => {
        if (action.payload) {
            state.poolBonusSettlementCustomerDetails = action.payload;
        }

        state.requesting = false;
    });
});
